import React, { FC } from 'react';

import './_preview-bar.scss';

export const PreviewBar: FC = () => (
  <div className="landing-page__preview-bar">
    You are viewing this page in preview mode
  </div>
);
